import { useQuery } from 'react-query';

import { getScheduleDelay as queryFn } from 'api/endPoints/getScheduleDelay';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetScheduleDelay = (params) => {
    return useQuery<string, QueryError, string, [QueryKeys, unknown]>({
        queryKey: ['getScheduleDelay', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId) && Boolean(params.contractId),
    });
};
